import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface UndoDeleteStorageAreaRequest {
  storageAreaId: string;
}

export interface UndoDeleteStorageAreaResponse {
  ok: true;
}

export function useUndoDeleteStorageArea() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: UndoDeleteStorageAreaRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`storagearea/${action.storageAreaId}/undo-delete`), {
      headers,
      method: 'PUT'
    });
    const text = translations.value.storageAreas.actions.undoDelete;
    const response = await httpClient.action<UndoDeleteStorageAreaResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk() {
        return {
          ok: true
        };
      }
    });

    return response;
  }
}
